var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('section',[_c('div',{staticClass:"tw-w-screen tw-p-2"},[_c('autocomplete-search',{attrs:{"api":"/api/admin/profiles/search","options":{
          placeholder: 'Search profiles',
          noResult: 'No profiles matching'
        },"custom-label":function (option) { return ((option.nickname) + " (" + (option.name) + ")"); }},on:{"onSelect":_vm.onSelect}}),_c('div',{staticClass:"tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 lg:tw-grid-cols-5 tw-gap-2"},_vm._l((_vm.profiles),function(profile){return _c('ProfileGridItem',{key:profile.uuid,attrs:{"data":profile,"route":{
            name: 'admin-profile'
          },"options":{
            show: {
              profession: false,
              distanceToUser: true,
              lastOnline: true,
            }
          }}})}),1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"SubMenu tw-bg-gradient2-lr tw-py-6"},[_c('div',{staticClass:"ns-container"},[_c('h1',{staticClass:"heading-white tw-text-center"},[_vm._v(" Nearby ")])])])}]

export { render, staticRenderFns }